// LG & P&F
const EXPECTED_PRESENT_ANNUAL_PENSION = 14_250.48;
const EXPECTED_PRESENT_LUMP_SUM = 42_751.44;
const EXPECTED_FINAL_GUARANTEE_AMOUNT = 1_247.63;
const EXPECTED_ANNUAL_PENSION = 18_640.32;
const EXPECTED_TAX_FREE_LUMP_SUM = 55_920.96;
const EXPECTED_ANNUAL_PENSION_AFTER_MAX_LUMP_SUM = 17_290.74;
const EXPECTED_TAX_FREE_LUMP_SUM_AFTER_MAXIMUM_LUMP_SUM = 86_451.6;
const EXPECTED_DEATH_GRANT_LUMP_SUM = 112_500.63;
const EXPECTED_ANNUAL_SURVIVORS_PENSION = 8_645.37;

// P&F specific
const EXPECTED_PRESENT_ALTERNATIVE_BENEFITS = 15_500.34;
const EXPECTED_ALTERNATIVE_BENEFITS = 19_250.5;
const EXPECTED_ALTERNATIVE_LUMP_SUM = 54_800.82;
const EXPECTED_ALTERNATIVE_BENEFITS_AFTER_MAX_LUMP_SUM = 18_103.48;
const EXPECTED_ALTERNATIVE_LUMP_SUM_AFTER_MAX_LUMP_SUM = 84_500.51;

const formatCurrency = (amount: number) =>
  amount.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const activeVideoData = {
  vA: formatCurrency(EXPECTED_PRESENT_ANNUAL_PENSION),
  vB: formatCurrency(EXPECTED_PRESENT_LUMP_SUM),
  vC: formatCurrency(EXPECTED_FINAL_GUARANTEE_AMOUNT),
  vD: formatCurrency(EXPECTED_ANNUAL_PENSION),
  vE: formatCurrency(EXPECTED_ANNUAL_PENSION / 12),
  vF: formatCurrency(EXPECTED_TAX_FREE_LUMP_SUM),
  vG: formatCurrency(EXPECTED_ANNUAL_PENSION_AFTER_MAX_LUMP_SUM),
  vH: formatCurrency(EXPECTED_ANNUAL_PENSION_AFTER_MAX_LUMP_SUM / 12),
  vI: formatCurrency(EXPECTED_TAX_FREE_LUMP_SUM_AFTER_MAXIMUM_LUMP_SUM),
  vJ: formatCurrency(EXPECTED_DEATH_GRANT_LUMP_SUM),
  vK: formatCurrency(EXPECTED_ANNUAL_SURVIVORS_PENSION),
};

export const deferredVideoData = {
  vC: formatCurrency(EXPECTED_FINAL_GUARANTEE_AMOUNT),
  vD: formatCurrency(EXPECTED_ANNUAL_PENSION),
  vF: formatCurrency(EXPECTED_TAX_FREE_LUMP_SUM),
  vJ: formatCurrency(EXPECTED_DEATH_GRANT_LUMP_SUM),
  vK: formatCurrency(EXPECTED_ANNUAL_SURVIVORS_PENSION),
};

export const policeAndFireVideoData = {
  vA: formatCurrency(EXPECTED_PRESENT_ANNUAL_PENSION),
  vB: formatCurrency(EXPECTED_PRESENT_LUMP_SUM),
  vD: formatCurrency(EXPECTED_ANNUAL_PENSION),
  vE: formatCurrency(EXPECTED_ANNUAL_PENSION / 12),
  vF: formatCurrency(EXPECTED_TAX_FREE_LUMP_SUM),
  vG: formatCurrency(EXPECTED_ANNUAL_PENSION_AFTER_MAX_LUMP_SUM),
  vH: formatCurrency(EXPECTED_ANNUAL_PENSION_AFTER_MAX_LUMP_SUM / 12),
  vI: formatCurrency(EXPECTED_TAX_FREE_LUMP_SUM_AFTER_MAXIMUM_LUMP_SUM),
  vJ: formatCurrency(EXPECTED_DEATH_GRANT_LUMP_SUM),
  vK: formatCurrency(EXPECTED_ANNUAL_SURVIVORS_PENSION),
  vL: formatCurrency(EXPECTED_PRESENT_ALTERNATIVE_BENEFITS),
  vM: formatCurrency(EXPECTED_ALTERNATIVE_BENEFITS),
  vN: formatCurrency(EXPECTED_ALTERNATIVE_BENEFITS / 12),
  vO: formatCurrency(EXPECTED_ALTERNATIVE_LUMP_SUM),
  vP: formatCurrency(EXPECTED_ALTERNATIVE_BENEFITS_AFTER_MAX_LUMP_SUM),
  vQ: formatCurrency(EXPECTED_ALTERNATIVE_BENEFITS_AFTER_MAX_LUMP_SUM / 12),
  vR: formatCurrency(EXPECTED_ALTERNATIVE_LUMP_SUM_AFTER_MAX_LUMP_SUM),
};
